// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const CustomerOrderProfitabilityLineKeyValues = [
	"REVENUE",
	"CUSTOMER_ORDER_LINE_COSTS",
	"CUSTOMER_ORDER_LINE_COST_WAREHOUSE",
	"CUSTOMER_ORDER_LINE_COST_PURCHASE_TRANSIT",
	"CUSTOMER_ORDER_LINE_COST_PURCHASE_DIRECT",
	"CUSTOMER_ORDER_LINE_COST_MANUFACTURE",
	"CUSTOMER_ORDER_LINE_COST_NO_ACQUISITION",
	"CUSTOMER_ORDER_LINE_COST_SPLIT_BOM",
	"PROJECT_MATERIAL_COSTS",
	"PROJECT_MATERIAL_COST_WAREHOUSE",
	"PROJECT_MATERIAL_COST_PURCHASE_TRANSIT",
	"PROJECT_MATERIAL_COST_PURCHASE_DIRECT",
	"PROJECT_MATERIAL_COST_MANUFACTURE",
	"PROJECT_MATERIAL_COST_NO_ACQUISITION",
	"PROJECT_MATERIAL_COST_SPLIT_BOM",
	"OTHER_COSTS",
	"PROJECT_COST_EVENTS",
	"CUSTOMER_ORDER_COST_EVENTS",
	"RECLAMATION_COSTS",
	"TOTAL_COSTS",
	"MARGIN",
	"MARGIN_PERCENT",
] as const;

export type CustomerOrderProfitabilityLineKey = (typeof CustomerOrderProfitabilityLineKeyValues)[number];

export const getCustomerOrderProfitabilityLineKeyLabels = () => ({
	REVENUE: t("revenue"),
	CUSTOMER_ORDER_LINE_COSTS: t("customer_order_lines"),
	CUSTOMER_ORDER_LINE_COST_WAREHOUSE: t("warehouse"),
	CUSTOMER_ORDER_LINE_COST_PURCHASE_TRANSIT: t("purchase_transit"),
	CUSTOMER_ORDER_LINE_COST_PURCHASE_DIRECT: t("purchase_direct"),
	CUSTOMER_ORDER_LINE_COST_MANUFACTURE: t("manufacture"),
	CUSTOMER_ORDER_LINE_COST_NO_ACQUISITION: t("no_acquisition"),
	CUSTOMER_ORDER_LINE_COST_SPLIT_BOM: t("split_bom"),
	PROJECT_MATERIAL_COSTS: t("project_materials"),
	PROJECT_MATERIAL_COST_WAREHOUSE: t("warehouse"),
	PROJECT_MATERIAL_COST_PURCHASE_TRANSIT: t("purchase_transit"),
	PROJECT_MATERIAL_COST_PURCHASE_DIRECT: t("purchase_direct"),
	PROJECT_MATERIAL_COST_MANUFACTURE: t("manufacture"),
	PROJECT_MATERIAL_COST_NO_ACQUISITION: t("no_acquisition"),
	PROJECT_MATERIAL_COST_SPLIT_BOM: t("split_bom"),
	OTHER_COSTS: t("other_costs"),
	PROJECT_COST_EVENTS: t("project_cost_events"),
	CUSTOMER_ORDER_COST_EVENTS: t("customer_order_cost_events"),
	RECLAMATION_COSTS: t("reclamations"),
	TOTAL_COSTS: t("total_costs"),
	MARGIN: t("margin.sales"),
	MARGIN_PERCENT: t("margin_percent"),
});

export const getCustomerOrderProfitabilityLineKeyLabel = (value: CustomerOrderProfitabilityLineKey): string => {
	return getCustomerOrderProfitabilityLineKeyLabels()[value];
};
